import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect, useRef, useState } from 'react';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import { DisplayListPagination } from '../../../components/TapUi';
import swal from "sweetalert";
import { toast } from 'react-toastify';
import AssetLinkingWithDevice from './AssetLinkingWithDevice';
import UpdateIotServer from './UpdateIotServer';
import SimLinking from './SimLinking';
import DeviceData from '../DeviceData';
import DeviceHistory from '../DeviceHistory';
import TripSessionDetail from '../TripSessionDetail';
import ConslidatedTripDetails from '../ConslidatedTripDetails';

const DeviceDataListing = ({ history, location }) => {
    const [minimizeTable, setMinimizeTable] = useState(false);
    const [deviceDetail, setDeviceDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deviceDataListing, setDeviceDataListing] = useState([]);
    const [detailLoading, setDetailLoading] = useState(false);
    const [listingMeta, setListingMeta] = useState(null);
    const [activeView, setActiveView] = useState('device_detail');

    const access_token = useSelector(state => state.auth.access_token);
    const assetLinkingModalRef = useRef(null);
    const simLinkingModalRef = useRef(null);

    const viewDeviceData = (id) => {
        setMinimizeTable(true);
        setActiveView('device_detail');
        setDetailLoading(true);
        HttpAPICall.withAthorization(
            'GET', BACKOFFICE_BASE_URL + '/device_detail/' + id, access_token, {}, {},
            (resp) => { setDeviceDetail(resp?.data) }
        ).then(() => {
            setDetailLoading(false);
        })
    }

    const closeView = () => {
        setMinimizeTable(false);
        setDeviceDetail(null);
        setActiveView('device_detail');
    };

    const editDeviceDataInit = (item) => {
        history.push({ pathname: `/device_add`, state: { editdeviceDataListing: item } });
    };

    const handleDeviceDataClick = () => {
        setActiveView('device_data');
    };

    const handleDeviceHistoryClick = () => {
        setActiveView('device_history');
    };

    const handleTripDetailsClick = () => {
        setActiveView('trip_details');
    };

    const handleConsolidateTripClick = () => {
        setActiveView('consolidate_trip');
    };

    const getDeviceDataListing = (page = 1) => {
        setLoading(true)
        const params = { page: page, per_page: 50, };
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/device_list', access_token, {}, params, (resp) => {
            const respData = resp?.data
            setDeviceDataListing(respData?.data);
            setListingMeta({
                'from': respData?.from,
                'to': respData?.to,
                'total': respData?.total,
                'last_page': respData?.last_page,
                'per_page': respData?.per_page,
                'current_page': respData?.current_page
            })
        }).then(() => setLoading(false))
    }

    const searchModalHandle = () => {
        if (assetLinkingModalRef.current) {
            assetLinkingModalRef.current.initModalHandler();
        }
    };

    const simLinkingHandle = () => {
        if (simLinkingModalRef.current) {
            simLinkingModalRef.current.initModalDataHandler();
        }
    };

    useEffect(() => {
        getDeviceDataListing(1)
        if (location?.state?.id) {
            viewDeviceData(location.state.id);
        }
    }, [])

    const deleteDeviceInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', BACKOFFICE_BASE_URL + '/device_delete/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    setMinimizeTable(false)
                    getDeviceDataListing(1);
                }).then(() => { });
            }
        });
    }

    const delinkingDeviceInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', BACKOFFICE_BASE_URL + '/device_asset_linking_delete/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    viewDeviceData(deviceDetail.id)
                    getDeviceDataListing(1);
                }).then(() => { });
            }
        });
    }

    const updateIotServer = () => {
        const payload = {
            device_id: deviceDetail.id,
            linked_id: deviceDetail?.linked_device?.id,
            'hour_applicable': deviceDetail?.linked_device?.hour_applicable,
            'odo_meter_applicable': deviceDetail?.linked_device?.odo_meter_applicable,
            'movable': deviceDetail?.linked_device?.movable,
        }
        swal({
            title: "Update",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: false,
            buttons: ["No", "Yes"],
        }).then(Update => {
            if (Update) {
                HttpAPICall.withAthorization("PUT", BACKOFFICE_BASE_URL + "/update_iot_server", access_token, {}, payload, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    viewDeviceData(deviceDetail.id)
                    getDeviceDataListing(1);
                }).then(() => { });
            }
        });
    };

    const delinkingSimInit = (id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
            dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', BACKOFFICE_BASE_URL + '/sim_de_linking/' + id, access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    viewDeviceData(deviceDetail.id)
                    getDeviceDataListing(1);
                }).then(() => { });
            }
        });
    }

    const deviceDataListingJsx = () => {
        return (
            <>
                <table className="table table-bordered table-fixed bg-white table-sm">
                    <thead className="table-secondary">
                        {minimizeTable ? (
                            <tr>
                                <th scope="col" style={{ width: "8%" }}>Device </th>
                            </tr>
                        ) : (
                            <tr>
                                <th className='text-center' style={{ width: "5%" }}>S.No.</th>
                                <th className='text-center ms-3' style={{ width: "10%" }}>Device Id</th>
                                <th className='text-center ms-3' style={{ width: "10%" }}>Device Type</th>
                                <th className='text-center ms-3' style={{ width: "10%" }}>Manufacturer</th>
                                <th className='text-center ms-3' style={{ width: "12%" }}>Model </th>
                                <th className='text-center ms-3' style={{ width: "12%" }}>IMEI</th>
                                <th className='text-center ms-3' style={{ width: "12%" }}>Group ID </th>
                                <th className='text-center ms-3' style={{ width: "17%" }}>Asset Name </th>
                                <th className='text-center ms-3' style={{ width: "12%" }}>Sim No </th>
                            </tr>
                        )}
                    </thead>
                    <tbody>
                        {loading
                            ?
                            <tr><td colSpan={9}><Loader /></td></tr>
                            :
                            deviceDataListing.length > 0
                                ?
                                deviceDataListing.map((i, k) => {
                                    return (<>
                                        <tr key={k}>
                                            {minimizeTable ? (
                                                <td style={{ width: "25%" }} className='text-start '>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <a
                                                        href="#"
                                                        className="text-capitalize link-primary"
                                                        onClick={() => viewDeviceData(i.id)}
                                                    >
                                                        {i.device_id}
                                                    </a>
                                                   <p className='mb-0'>{i.imei_no || "-"}</p> 
                                                    </div>
                                                </td>
                                            ) : (
                                                <>
                                                    <td className='text-center'>{k + 1}</td>
                                                    <td className='text-center'>
                                                        <a href="#" className="text-capitalize link-primary"
                                                            onClick={() => viewDeviceData(i.id)}>
                                                            {i.device_id}
                                                        </a>
                                                    </td>
                                                    <td className='text-center'> {i.device_type || "-"}
                                                    </td>
                                                    <td className='text-center'> {i.manufacturer?.name || "-"}
                                                    </td>
                                                    <td className='text-center'> {i.modal || "-"} </td>
                                                    <td className='text-center'> {i.imei_no || "-"} </td>
                                                    <td className='text-center'> {i?.group?.group_name || "-"}</td>
                                                    <td className='text-center'> {i?.asset?.asset_name || "-"}</td>
                                                    <td className='text-center'> {i.sim_number || "-"}</td>
                                                </>
                                            )}
                                        </tr>
                                    </>)
                                })
                                :
                                <tr><td colSpan="9" className="text-center">No Records</td></tr>
                        }
                    </tbody>
                </table>
                <DisplayListPagination meta={listingMeta} onPageChange={(e) => getDeviceDataListing(e.selected + 1)} />
            </>
        );
    };

    const renderActiveView = () => {
        if (!deviceDetail) return null;
        switch (activeView) {
            case 'device_data':
                return <DeviceData deviceData={deviceDetail}  />;
            case 'device_history':
                return <DeviceHistory deviceData={deviceDetail} />;
            case 'trip_details':
                return <TripSessionDetail deviceData={deviceDetail} />;
            case 'consolidate_trip':
                return <ConslidatedTripDetails deviceData={deviceDetail} />;
            case 'device_detail':
            default:
                return deviceDataDetails();
        }
    };

    const deviceDataJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className={minimizeTable ? "col-3" : "col-12"}>
                        <h3>Device </h3>
                        {(!minimizeTable) ? (
                            <div className="text-end mt15">
                                <>
                                    <Link to="/device_add">
                                        <button type="button" className="btn btn-primary">Add</button>
                                    </Link>
                                </>
                            </div>
                        ) : null}
                    </div>
                    {minimizeTable ? (
                        <div className="col-9 tap_border_left">
                            <div className="d-flex justify-content-between align-items-center">
                                <h3 className="mb-0">
                                    {activeView === 'device_detail' && 'Device Detail'}
                                    {activeView === 'device_data' && 'Device Data'}
                                    {activeView === 'device_history' && 'Device History'}
                                    {activeView === 'trip_details' && 'Trip Details'}
                                    {activeView === 'consolidate_trip' && 'Consolidate Trip Details'}
                                </h3>
                                <div className="text-end mt15">
                                    <span className="dropdown">
                                        <button
                                            type="button"
                                            id='actionMenuButton'
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="btn btn-secondary"
                                        >
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faChartBar} className="img-fluid mr3" alt="item-action" />
                                            Report
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleDeviceDataClick}
                                                >
                                                    Device Data
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleDeviceHistoryClick}
                                                >
                                                    Device History
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleTripDetailsClick}
                                                >
                                                    Trip Details
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className='dropdown-item'
                                                    onClick={handleConsolidateTripClick}
                                                >
                                                    Consolidate Running
                                                </button>
                                            </li>
                                        </ul>
                                    </span>
                                    <span className="dropdown">
                                        <button
                                            type="button"
                                            id='actionMenuButton'
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            className="btn btn-secondary"
                                        >
                                            <TapIcon.imageIcon icon={TapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                        </button>
                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <li>
                                                <button className='dropdown-item' onClick={() => editDeviceDataInit(deviceDetail)}>Edit</button>
                                            </li>
                                            {deviceDetail?.linked_device?.id
                                                ?
                                                <li>
                                                    <button className='dropdown-item' onClick={() => delinkingDeviceInit(deviceDetail?.linked_device?.id)}>Delink with Asset</button>
                                                </li>
                                                :
                                                <li>
                                                    <button className='dropdown-item' onClick={searchModalHandle}>Link With Asset</button>
                                                </li>}

                                            {deviceDetail?.linked_device && <li>
                                                <button className='dropdown-item' onClick={updateIotServer}>Update IOT Server</button>
                                            </li>}
                                            {deviceDetail?.linked_sim?.id
                                                ?
                                                <li>
                                                    <button className='dropdown-item' onClick={() => delinkingSimInit(deviceDetail?.linked_sim?.id)}>Delink Sim</button>
                                                </li>
                                                :
                                                <li>
                                                    <button className='dropdown-item' onClick={simLinkingHandle}>Update Sim Linking</button>
                                                </li>
                                            }
                                            <li>
                                                <button className='dropdown-item' onClick={() => deleteDeviceInit(deviceDetail?.id)}>Delete</button>
                                            </li>
                                        </ul>
                                    </span>
                                    <button
                                        type="button"
                                        className="btn btn-secondary ms-2"
                                        onClick={closeView}
                                    >
                                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', minimizeTable ? 'col-3' : 'col-12'].join(' ')}>
                            {deviceDataListingJsx()}
                        </div>
                        {minimizeTable ? (
                            <div className="col-9 pr4 pl4">
                                <div className="bg-white p-2" style={{ height: "100%" }}>
                                    {renderActiveView()}
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    };

    const deviceDataDetails = () => {

        return (
            <div className="tab_content_header">
                <div className="tab_content_wrapper">
                    <span className="content_heading">Device Details</span>
                </div>
                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        {detailLoading ? <Loader /> :
                            (<> <tr>
                                <td style={{ width: "26%" }}>Icmei</td>
                                <th>{deviceDetail?.imei_no || "-"}</th>
                            </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Device ID</td>
                                    <th>{deviceDetail?.device_id || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Device Type</td>
                                    <th>{deviceDetail?.device_type || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Product Serial No</td>
                                    <th>{deviceDetail?.product_serial_no || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Manufacturer</td>
                                    <th>{deviceDetail?.manufacturer?.name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Model</td>
                                    <th>{deviceDetail?.modal || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Notes</td>
                                    <th>{deviceDetail?.notes || "-"}</th>
                                </tr>

                            </>)}
                    </tbody>
                </table>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Asset Details</span>
                </div>
                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        {detailLoading ? <Loader /> :
                            (<>
                                <tr>
                                    <td style={{ width: "26%" }}>Group ID</td>
                                    <th>{deviceDetail?.group?.master?.tap_master_id || "-"}</th>
                                </tr> <tr>
                                    <td style={{ width: "26%" }}>Group Name</td>
                                    <th>{deviceDetail?.group?.group_name || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Asset Name</td>
                                    <th>{deviceDetail?.asset?.asset_name || "-"}</th>
                                </tr>
                            </>)}
                    </tbody>
                </table>
                <div className="tab_content_wrapper">
                    <span className="content_heading">Configuration Details</span>
                </div>
                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        {detailLoading ? <Loader /> :
                            (<> <tr>
                                <td style={{ width: "26%" }}>Hour Applicable</td>
                                <th>{deviceDetail?.linked_device?.hour_applicable || "-"}</th>
                            </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>OdoMeter Applicable</td>
                                    <th>{deviceDetail?.linked_device?.odo_meter_applicable || "-"}</th>
                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Movable</td>
                                    <th>{deviceDetail?.linked_device?.movable || "-"}</th>
                                </tr>
                            </>)}
                    </tbody>
                </table>
                <div className="tab_content_wrapper">
                    <span className="content_heading">SIM Details</span>
                </div>

                <table className="table table-hover table-bordered table-responsive bg-white my-2 mb-3">
                    <tbody>
                        {detailLoading ? <Loader /> :
                            (<> <tr>
                                <td style={{ width: "26%" }}>Service Provider Name</td>
                                <th>{deviceDetail?.linked_sim?.provider_name || "-"}</th>

                            </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>Network Type</td>
                                    <th>{deviceDetail?.linked_sim?.network_type || "-"}</th>

                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>ICCID</td>
                                    <th>{deviceDetail?.linked_sim?.mobile_number || "-"}</th>

                                </tr>
                                <tr>
                                    <td style={{ width: "26%" }}>MSSIDN</td>
                                    <th>{deviceDetail?.linked_sim?.sim_number || "-"}</th>

                                </tr>
                            </>)}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <ApplicationLayout>
            <Helmet><title>Device Data Listing</title></Helmet>
            {deviceDataJsx()}
            <AssetLinkingWithDevice
                ref={assetLinkingModalRef}
                detailData={deviceDetail}
                onLinkSuccess={(deviceId) => {
                    viewDeviceData(deviceId);
                    getDeviceDataListing(listingMeta?.current_page || 1);
                }}
            />
            <SimLinking ref={simLinkingModalRef} detailData={deviceDetail}
                onLinkSuccess={(deviceId) => {
                    viewDeviceData(deviceId);
                    getDeviceDataListing(listingMeta?.current_page || 1);
                }} />
        </ApplicationLayout>
    );
};

export default DeviceDataListing;
